// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__WYgz_","img":"Banner_img__1ILhI"};